import {
  DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_BEGIN,
  DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_SUCCESS,
  DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_FAILURE,
  DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
export function updateTablesAndFields(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_BEGIN,
    });
    const { projectId, version, dbUuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/supabase/fields-tables/${dbUuid}`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateTablesAndFieldsError() {
  return {
    type: DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_BEGIN:
      return {
        ...state,
        updateTablesAndFieldsPending: true,
        updateTablesAndFieldsError: null,
      };

    case DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_SUCCESS:
      return {
        ...state,
        updateTablesAndFieldsPending: false,
        updateTablesAndFieldsError: null,
      };

    case DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_FAILURE:
      return {
        ...state,
        updateTablesAndFieldsPending: false,
        updateTablesAndFieldsError: action.data.error,
      };

    case DATA_CONNECTOR_UPDATE_TABLES_AND_FIELDS_DISMISS_ERROR:
      return {
        ...state,
        updateTablesAndFieldsError: null,
      };

    default:
      return state;
  }
}
